import React from "react";
import { Sidebar } from "../../components/Sidebar";
import { useGreenMilesDemos } from "../../components/GreenMiles/Demos/hooks/useGreenMilesDemos";
import GreenMilesPageHeader from "../../components/GreenMiles/Home/GreenMilesPageHeader";
import GreenMilesDemosTable from "../../components/GreenMiles/Demos/GreenMilesDemosTable";
import { LoadingState, ErrorState } from "../../components/UI";
import { useNavigate } from "react-router-dom";

const GreenMilesDemos = () => {
  const { demos, loading, error, sortState, handleSort } = useGreenMilesDemos();
  const navigate = useNavigate();

  // États de chargement et d'erreur
  if (loading) {
    return <LoadingState message="Chargement des démos GreenMiles..." />;
  }

  if (error) {
    return <ErrorState error={error} />;
  }

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-4 overflow-auto">
        {/* Sous-onglets */}
        <div className="mb-6">
          <div className="flex space-x-2 border-b border-gray-200">
            <button className="px-4 py-2 text-sm font-medium border-b-2 border-[#365644] text-[#365644]">Liste des démos</button>
            <button className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-[#365644]" onClick={() => navigate("/greenmiles/create-demo")}>
              Créer une démo
            </button>
          </div>
        </div>
        <GreenMilesDemosTable hotels={demos} sortState={sortState} onSort={handleSort} />
      </div>
    </div>
  );
};

export default GreenMilesDemos;
